import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b04a840e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=b04a840e&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=b04a840e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04a840e",
  null
  
)

export default component.exports